import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';

function Divider({ condition, small }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={clsx(classes.root, small && classes.rootSmall)}>
      {!small && <div className={classes.line} />}

      <span className={clsx(classes.condition, classes[condition])}>
        {t(`filter-label-${condition}`)}
      </span>
    </div>
  );
}

Divider.defaultProps = {
  small: false,
};

Divider.propTypes = {
  small: PropTypes.bool.isRequired,
  condition: PropTypes.oneOf(['AND', 'OR']),
};

export default React.memo(Divider);
